/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION ADVANCED SECTION - ARTICLE REDIRECT : STYLES --------------- ++++++++++ */
export default theme => ({
  articleredirect: {

  }
});
